import React, { useContext } from "react";
import { MixCardStyled } from "./MixCardStyled";
import { MixCardProps } from "../../../entities/Mix";
import Button from "../../../UI/Button";
import { useAppDispatch } from "../../../store/store";
import { MODAL_TYPES } from "../../../entities/Modal";
import { onOpenModal } from "../../Modal/slice/ModalSlice";
import { useNavigate } from "react-router-dom";
import { VIEW_TYPE } from "../../../entities/Filter";
import { TranslationContextInterface } from "../../../entities/Language";
import { TranslationContext } from "../../../context/TranslationContext";
import { getValueForKey } from "../../../context/translationsUtils";
import { TEST_ID } from "../../../shared/testid";
import ImageComponent from "../../../UI/ImageComponent";
import { useSelector } from "react-redux";
import { getTenantCredentials } from "../../Tenant/selectors";

const MixCard: React.FC<MixCardProps> = ({
  mix,
  view = VIEW_TYPE.GRID,
}: MixCardProps) => {
  const credentials = useSelector(getTenantCredentials);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { translations }: TranslationContextInterface =
    useContext(TranslationContext);
  const { id, image, name, description, categories, condiments } = mix;

  const onHandleMore = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ): void => {
    event.stopPropagation();
    dispatch(
      onOpenModal({
        modalType: MODAL_TYPES.PRODUCT_PREVIEW,
        content: {
          id,
          name,
          image,
          description,
          condiments,
          categories,
          type: "mix",
        },
      }),
    );
  };

  return (
    <MixCardStyled
      className={`view-${view}`}
      data-testid={TEST_ID.MIXES.CARD}
      data-mixid={id}
    >
      <div
        className="mix-card__wrapper"
        onClick={() => {
          return !location.pathname?.includes("mixes")
            ? navigate(`${location.pathname}/mixes/${id}`)
            : navigate(`/mixes/${id}`);
        }}
        role="button"
      >
        <div className="mix-card__left">
          <div className="mix-card__image">
            <ImageComponent url={image} name={name} />
          </div>
        </div>
        <div className="mix-card__right">
          <div className="mix-card__name">{name}</div>
          <div className="mix-card__description">{description}</div>
          <div className="mix-card__more">
            <Button
              name={getValueForKey(translations, "default.more_button")}
              className="mix-btn full-btn"
            bgColor={credentials?.webshopDesigns?.at(0)?.colorButtonMore}
              onClick={(e) => onHandleMore(e)}
            />
          </div>
        </div>
      </div>
    </MixCardStyled>
  );
};

export default MixCard;
